import React from 'react'

import { useRetentionFlowV2Config } from '../../hooks/useRetentionFlowV2Config'
import { StyledFlowScope as S } from './FlowScope.styles'

type TProps = {
  children: React.ReactNode
}

export const FlowScope: React.FC<TProps> = ({ children }) => {
  const { appName } = useRetentionFlowV2Config()

  return <S.Wrapper appName={appName}>{children}</S.Wrapper>
}
